export const inputAriaLabels = {
  MM: 'month',
  DD: 'day',
  YYYY: 'year'
};
